import { PhoneNumberUtil } from 'google-libphonenumber';

import { t } from '../services/translation/translation';

const phoneUtil = PhoneNumberUtil.getInstance();

export const noop = () => {
  // Do nothing
};

export const assertNever = (value: never, errorMessage: string) => {
  console.error('assertNever', value, errorMessage);
};

export type AnonymousTokenData = {
  fareEncodedKey: string;
  id: number;
};

export const getFullName = (firstName?: string, lastName?: string) => {
  if (!firstName && !lastName) return t('common.unknown');
  if (!firstName) return lastName as string;
  if (!lastName) return firstName;
  return `${firstName} ${lastName}`;
};

export const isPhoneValid = (phone: string) => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch (error) {
    return false;
  }
};
